<template>
  <div class="relation-detail">
	<div class="section-box">
		<div class="section-box-inner">
			<div class="userinfo">
				<div class="userinfo-l"><img src="@assets/images/assemble.jpg" alt=""></div>
				<div class="userinfo-r">
					<div class="userinfo-r-name">
						牛牛去哪了
						<i v-if="!isXingShow" class="iconfont icon-shitixing"></i>
					</div>
					<div v-if="isXingShow" @click="clickXing()" class="userinfo-r-xb">
						<i class="iconfont icon-kongxinxing"></i> 星标客户
					</div>
					<div v-if="!isXingShow" @click="clickXing()" class="userinfo-r-xb">取消星标</div>
				</div>
			</div>
			<!-- 备注 -->
			<div class="remarks">
				备注<span class="remarks-text">{{ remarksText }}</span><i class="iconfont icon-bianji1"></i>
			</div>
		</div>
	</div>
	<div class="section-box">
		<ul class="sale-info">
			<li>
				<h3>2</h3>
				<p>订单数量</p>
			</li>
			<li>
				<h3>2.22</h3>
				<p>成交金额（元）</p>
			</li>
			<li>
				<h3>2</h3>
				<p>客单价（元）</p>
			</li>
			<li>
				<h3>2020-02-02</h3>
				<p>最后成交时间</p>
			</li>
		</ul>
	</div>
	<div class="section-box">
		<ul class="relation-tab">
			<li class="on">客户关系</li>
		</ul>
		<ul class="relation-info">
			<li>
				<span>客户绑定渠道</span>
				<span class="right">公众号</span>
			</li>
			<li>
				<span>客户关系更新时间</span>
				<span class="right">2020-2</span>
			</li>
			<li>
				<span>保护期剩余</span>
				<span class="right">0天</span>
			</li>
			<li>
				<span>有效期剩余</span>
				<span class="right">0天</span>
			</li>
			<li>
				<span>绑定时间</span>
				<span class="right">2020</span>
			</li>
		</ul>
	</div>
  </div>
</template>
<script>

export default {
  name: "RelationDetail",
  components: {},
  props: {},
  data: function() {
    return {
	  isXingShow:true,
	  remarksText:"牛牛去哪了"
    };
  },
  watch: {
    $route(n) {
      
    }
  },
  mounted: function() {
    
  },
  methods: {
    clickXing(){
		this.isXingShow = !this.isXingShow;
	}
  }
};
</script>
<style scoped>
img{display: block;width: 100%;}
.relation-detail{padding: 0 0.2rem;}
.section-box{background-color: #fff;margin-top: 0.2rem;border-radius: 5px;}
/* 第一个div */
.section-box-inner{padding: 0.3rem 0.15rem;}
.section-box-inner .userinfo{display: flex;justify-content: flex-start;}
.userinfo-l{width: 1rem;height: 1rem;border-radius: 50%;overflow: hidden;}
.userinfo-r{margin-left: 0.3rem;}
.userinfo-r-name{font-size: 0.32rem;font-weight: bold;}
.userinfo-r-xb{border: 1px solid #ebedf0;border-radius: 17px;color: #666;font-size: 0.26rem;margin-top: 0.1rem;width: 1.7rem;text-align: center;height: 0.45rem;line-height: 0.4rem;}
.icon-kongxinxing{font-size: 0.28rem;color: #ccc;}
.icon-shitixing{font-size: 0.28rem;color: #fecf36;}
.remarks{padding-top: 0.2rem;border-top: 1px solid #ebedf0;margin-top: 0.3rem;color: #999;}
.remarks .icon-bianji1{font-size: 0.3rem;}
.remarks-text{margin: 0 0.1rem;color: #333;}
/* 第二个div */
.sale-info{padding: 0 0.3rem 0.4rem 0.3rem;overflow: hidden;}
.sale-info li{margin-top: 0.4rem;float: left;width: 50%;}
.sale-info li h3{font-size: 0.32rem;}
.sale-info li p{color: #999;font-size: 0.26rem;}
/* 第三个div */
.relation-tab{border-bottom: 1px solid #edeff1;display: flex;justify-content: space-around;padding: 0.2rem 0;}
/* .relation-tab li.on::after{display: block;width: 0.5rem;height: 0.1rem;content: '';background-color: #fd7226;margin: 0.15rem auto 0 auto;} */
.relation-info{padding: 0.3rem;}
.relation-info li{display: flex;justify-content: space-between;margin-top: 0.4rem;}
.relation-info li .right{color: #999;}
</style>
